import React from 'react';
import styles from './index.module.css';

export default function MentorTag() {
  return <span className={styles.tag}>Mentor</span>;
}
